import React from "react";

const Carousel = () => {
  return (
    <div>
      <section className="home-banner-out bg-black">
        {/* Swiper  */}
        <div className="swiper-container">
          <div className="swiper-wrapper">
            <div className="swiper-slide home-banner">
              <div className="bg-overlay bg-black"></div>
              <img
                src="images/banner-1.jpg"
                className="img-fluid img-100"
                alt=""
              />
            </div>
            <div className="swiper-slide home-banner">
              <div className="bg-overlay bg-black"></div>
              <img
                src="images/banner-2.jpg"
                className="img-fluid img-100"
                alt=""
              />
            </div>
            <div className="swiper-slide home-banner">
              <div className="bg-overlay bg-black"></div>
              <img
                src="images/banner-3.jpg"
                className="img-fluid img-100"
                alt=""
              />
            </div>
          </div>
          <h1>
            Where practicality meets
            <br />
            everyday elegance
          </h1>
          <div className="slider-link">
            <a href="project-list.html">All Projects</a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Carousel;
